module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work"
  }, [_vm._m(0), _vm._v(" "), (_vm.works.length == 0) ? _c('div', {
    staticClass: "notification"
  }, [_c('span', [_vm._v(" 未上传作品 ")])]) : _c('div', [_c('ul', {
    staticClass: "categorywork clearfix"
  }, _vm._l((_vm.works), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'noright': index % 4 == 3
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + item.cover,
        "alt": "未上传封面"
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(item.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "categorycon"
    }, [(item.coworker != '') ? _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("合作者：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(item.coworker))])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("指导老师：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(item.teacher))])]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("年 级：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(_vm.convertGrade(item.gid)))])])])])
  }), 0), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-page",
    staticStyle: {
      "width": "40%",
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "margin-right": "100px"
    },
    attrs: {
      "current-page": parseInt(_vm.page),
      "page-sizes": [20, 30, 50],
      "page-size": parseInt(_vm.rows),
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": parseInt(_vm.count)
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("我的作品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c77593a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
// module id = 617
// module chunks = 1